import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/esnext.json.parse.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vShow as _vShow } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200 shrink-0"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "flex border-b border-slate-200 px-6 shrink-0"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "h-[560px] overflow-y-auto p-6"
};
const _hoisted_6 = {
  class: "space-y-4"
};
const _hoisted_7 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_8 = ["disabled"];
const _hoisted_9 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_10 = {
  class: "grid grid-cols-3 gap-4"
};
const _hoisted_11 = {
  class: "flex items-center gap-2 cursor-pointer"
};
const _hoisted_12 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_13 = {
  class: "space-y-4"
};
const _hoisted_14 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_15 = {
  key: 0,
  class: "text-center py-8 text-slate-400 text-sm"
};
const _hoisted_16 = {
  key: 1,
  class: "space-y-3"
};
const _hoisted_17 = {
  class: "flex items-start gap-4"
};
const _hoisted_18 = {
  class: "flex-1 grid grid-cols-2 gap-3"
};
const _hoisted_19 = ["onUpdate:modelValue"];
const _hoisted_20 = ["onUpdate:modelValue"];
const _hoisted_21 = ["onUpdate:modelValue"];
const _hoisted_22 = ["onUpdate:modelValue"];
const _hoisted_23 = {
  class: "flex items-center gap-2 pt-5"
};
const _hoisted_24 = {
  class: "flex items-center gap-1 cursor-pointer"
};
const _hoisted_25 = ["onUpdate:modelValue"];
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
  class: "h-[500px]"
};
const _hoisted_28 = {
  class: "flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-xl shrink-0"
};
import { ref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import FormBuilder from './FormBuilder.vue';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'DefinitionFormModal',
  props: {
    definition: {
      type: Object,
      default: null
    },
    categoryId: {
      type: Number,
      default: null
    }
  },
  emits: ['close', 'save'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const activeTab = ref('basic');
    const selectedCategoryName = ref('');
    const tabs = [{
      key: 'basic',
      label: '基础信息'
    }, {
      key: 'file',
      label: '文件配置'
    }, {
      key: 'form',
      label: '表单设计'
    }];
    const form = reactive({
      categoryId: null,
      code: '',
      name: '',
      nameAlias: '',
      description: '',
      allowMultiple: 0,
      sort: 0,
      status: 1,
      fileConfig: {
        files: []
      },
      formSchema: {
        type: 'object',
        properties: {},
        required: []
      }
    });
    onMounted(() => {
      if (props.definition) {
        // 编辑模式
        form.categoryId = props.definition.categoryId;
        form.code = props.definition.code;
        form.name = props.definition.name;
        form.nameAlias = props.definition.nameAlias || '';
        form.description = props.definition.description || '';
        form.allowMultiple = props.definition.allowMultiple ? 1 : 0;
        form.sort = props.definition.sort || 0;
        form.status = props.definition.status || 1;

        // 解析JSON字段
        if (props.definition.fileConfig) {
          try {
            form.fileConfig = typeof props.definition.fileConfig === 'string' ? JSON.parse(props.definition.fileConfig) : props.definition.fileConfig;
          } catch (e) {
            form.fileConfig = {
              files: []
            };
          }
        }
        if (props.definition.formSchema) {
          try {
            form.formSchema = typeof props.definition.formSchema === 'string' ? JSON.parse(props.definition.formSchema) : props.definition.formSchema;
          } catch (e) {
            form.formSchema = {
              type: 'object',
              properties: {},
              required: []
            };
          }
        }
      } else {
        // 新增模式
        form.categoryId = props.categoryId;
      }
    });
    function addFileField() {
      form.fileConfig.files.push({
        fieldCode: '',
        label: '',
        required: false,
        accept: '',
        maxSize: 0
      });
    }
    function removeFileField(index) {
      form.fileConfig.files.splice(index, 1);
    }
    function handleSave() {
      // 基础信息校验
      if (!form.categoryId) {
        ElMessage.warning('请选择分类');
        activeTab.value = 'basic';
        return;
      }
      if (!form.code.trim()) {
        ElMessage.warning('请输入类型编码');
        activeTab.value = 'basic';
        return;
      }
      if (!form.name.trim()) {
        ElMessage.warning('请输入类型名称');
        activeTab.value = 'basic';
        return;
      }

      // 表单设计校验
      if (form.formSchema.properties && Object.keys(form.formSchema.properties).length > 0) {
        const errors = [];
        const fieldNames = new Set();

        // 检查 required 数组中是否有空字段名
        if (form.formSchema.required && form.formSchema.required.length > 0) {
          const emptyRequired = form.formSchema.required.filter(f => !f || !f.trim());
          if (emptyRequired.length > 0) {
            errors.push('必填字段中存在无效字段名，请检查表单设计');
          }
        }
        for (const [fieldName, config] of Object.entries(form.formSchema.properties)) {
          // 检查字段名是否为空
          if (!fieldName || !fieldName.trim()) {
            errors.push('存在字段名为空的字段，请删除或填写标题');
            continue;
          }

          // 检查字段名是否重复
          if (fieldNames.has(fieldName)) {
            errors.push(`字段名"${fieldName}"重复`);
          }
          fieldNames.add(fieldName);

          // 检查标题是否为空
          if (!config.title || !config.title.trim()) {
            errors.push(`字段"${fieldName}"的标题不能为空`);
          }

          // 检查枚举值是否为空（如果是下拉选择）
          if (config.type === 'select') {
            if (!config.enumValues || config.enumValues.length === 0) {
              errors.push(`字段"${fieldName}"的枚举值不能为空`);
            }
          }

          // 检查日期格式是否有效（如果是日期类型）
          if (config.type === 'date') {
            const validFormats = ['date', 'datetime', 'time'];
            if (!config.format || !validFormats.includes(config.format)) {
              errors.push(`字段"${fieldName}"的日期格式无效，请选择日期、日期时间或时间`);
            }
          }
        }
        if (errors.length > 0) {
          ElMessage.warning(errors.join('；'));
          activeTab.value = 'form';
          return;
        }
      }
      const payload = {
        categoryId: form.categoryId,
        code: form.code,
        name: form.name,
        nameAlias: form.nameAlias || null,
        description: form.description || null,
        allowMultiple: form.allowMultiple,
        sort: form.sort || 0,
        status: form.status,
        fileConfig: form.fileConfig.files.length > 0 ? form.fileConfig : null,
        formSchema: Object.keys(form.formSchema.properties || {}).length > 0 ? form.formSchema : null
      };
      emit('save', payload);
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(AppModal, {
        visible: true,
        size: "6xl",
        "panel-class": "mx-4",
        onClose: _cache[11] || (_cache[11] = $event => _ctx.$emit('close'))
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(__props.definition ? '编辑资料类型' : '新增资料类型'), 1), _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('close')),
          class: "p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors cursor-pointer"
        }, [...(_cache[12] || (_cache[12] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, tab => {
          return _createElementVNode("button", {
            key: tab.key,
            onClick: $event => activeTab.value = tab.key,
            class: _normalizeClass(["px-4 py-3 text-sm font-medium border-b-2 transition-colors cursor-pointer", activeTab.value === tab.key ? 'text-primary-600 border-primary-600' : 'text-slate-500 border-transparent hover:text-slate-700'])
          }, _toDisplayString(tab.label), 11, _hoisted_4);
        }), 64))]), _createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_cache[13] || (_cache[13] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createTextVNode(" 分类 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(_component_el_select, {
          modelValue: form.categoryId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.categoryId = $event),
          class: "form-select w-full",
          disabled: !!__props.categoryId
        }, {
          default: _withCtx(() => [__props.categoryId ? (_openBlock(), _createBlock(_component_el_option, {
            key: 0,
            label: selectedCategoryName.value,
            value: __props.categoryId
          }, null, 8, ["label", "value"])) : (_openBlock(), _createBlock(_component_el_option, {
            key: 1,
            label: "请选择分类",
            value: null
          }))]),
          _: 1
        }, 8, ["modelValue", "disabled"])]), _createElementVNode("div", null, [_cache[14] || (_cache[14] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createTextVNode(" 类型编码 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.code = $event),
          type: "text",
          disabled: !!__props.definition,
          class: "form-input w-full",
          placeholder: "如: id_card, contract"
        }, null, 8, _hoisted_8), [[_vModelText, form.code]])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", null, [_cache[15] || (_cache[15] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createTextVNode(" 类型名称 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.name = $event),
          type: "text",
          class: "form-input w-full",
          placeholder: "如: 身份证信息"
        }, null, 512), [[_vModelText, form.name]])]), _createElementVNode("div", null, [_cache[16] || (_cache[16] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "别名", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.nameAlias = $event),
          type: "text",
          class: "form-input w-full",
          placeholder: "如: 证件"
        }, null, 512), [[_vModelText, form.nameAlias]])])]), _createElementVNode("div", null, [_cache[17] || (_cache[17] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "描述", -1)), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.description = $event),
          rows: "2",
          class: "form-textarea",
          placeholder: "请输入资料类型描述"
        }, null, 512), [[_vModelText, form.description]])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", null, [_createElementVNode("label", _hoisted_11, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.allowMultiple = $event),
          type: "checkbox",
          "true-value": 1,
          "false-value": 0,
          class: "w-4 h-4 text-primary-600 border-slate-300 rounded focus:ring-primary-500"
        }, null, 512), [[_vModelCheckbox, form.allowMultiple]]), _cache[18] || (_cache[18] = _createElementVNode("span", {
          class: "text-sm text-slate-700"
        }, "允许多个", -1))])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", null, [_cache[19] || (_cache[19] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "排序", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.sort = $event),
          type: "number",
          class: "form-input w-full"
        }, null, 512), [[_vModelText, form.sort, void 0, {
          number: true
        }]])]), _createElementVNode("div", null, [_cache[20] || (_cache[20] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "状态", -1)), _createVNode(_component_el_select, {
          modelValue: form.status,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.status = $event),
          class: "form-select w-full"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "启用",
            value: 1
          }), _createVNode(_component_el_option, {
            label: "禁用",
            value: 0
          })]),
          _: 1
        }, 8, ["modelValue"])])])], 512), [[_vShow, activeTab.value === 'basic']]), _withDirectives(_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
          class: "flex items-center justify-between mb-4"
        }, [_cache[22] || (_cache[22] = _createElementVNode("h4", {
          class: "text-sm font-medium text-slate-700"
        }, "文件上传配置", -1)), _createElementVNode("button", {
          onClick: addFileField,
          class: "px-3 py-1.5 bg-primary-700 text-white rounded-lg text-xs hover:bg-primary-800 transition-colors flex items-center gap-1 cursor-pointer"
        }, [...(_cache[21] || (_cache[21] = [_createElementVNode("svg", {
          class: "w-3.5 h-3.5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1), _createTextVNode(" 添加字段 ", -1)]))])]), form.fileConfig.files.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_15, " 暂未配置文件上传字段，点击\"添加字段\"开始配置 ")) : (_openBlock(), _createElementBlock("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.fileConfig.files, (file, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "bg-white rounded-lg border border-slate-200 p-4"
          }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", null, [_cache[23] || (_cache[23] = _createElementVNode("label", {
            class: "block text-xs font-medium text-slate-500 mb-1"
          }, "字段编码", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => file.fieldCode = $event,
            type: "text",
            class: "form-input w-full",
            placeholder: "如: front_photo"
          }, null, 8, _hoisted_19), [[_vModelText, file.fieldCode]])]), _createElementVNode("div", null, [_cache[24] || (_cache[24] = _createElementVNode("label", {
            class: "block text-xs font-medium text-slate-500 mb-1"
          }, "字段标签", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => file.label = $event,
            type: "text",
            class: "form-input w-full",
            placeholder: "如: 正面照片"
          }, null, 8, _hoisted_20), [[_vModelText, file.label]])]), _createElementVNode("div", null, [_cache[25] || (_cache[25] = _createElementVNode("label", {
            class: "block text-xs font-medium text-slate-500 mb-1"
          }, "接受类型", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => file.accept = $event,
            type: "text",
            class: "form-input w-full",
            placeholder: "如: image/*,.pdf,.doc"
          }, null, 8, _hoisted_21), [[_vModelText, file.accept]])]), _createElementVNode("div", null, [_cache[26] || (_cache[26] = _createElementVNode("label", {
            class: "block text-xs font-medium text-slate-500 mb-1"
          }, "最大大小(KB)", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => file.maxSize = $event,
            type: "number",
            min: "0",
            class: "form-input w-full",
            placeholder: "0为不限制"
          }, null, 8, _hoisted_22), [[_vModelText, file.maxSize, void 0, {
            number: true
          }]])])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("label", _hoisted_24, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => file.required = $event,
            type: "checkbox",
            class: "w-4 h-4 text-primary-600 border-slate-300 rounded focus:ring-primary-500"
          }, null, 8, _hoisted_25), [[_vModelCheckbox, file.required]]), _cache[27] || (_cache[27] = _createElementVNode("span", {
            class: "text-xs text-slate-600"
          }, "必填", -1))]), _createElementVNode("button", {
            onClick: $event => removeFileField(index),
            class: "p-1 text-red-500 hover:bg-red-50 rounded transition-colors cursor-pointer"
          }, [...(_cache[28] || (_cache[28] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_26)])])]);
        }), 128))]))])], 512), [[_vShow, activeTab.value === 'file']]), _withDirectives(_createElementVNode("div", _hoisted_27, [_createVNode(FormBuilder, {
          modelValue: form.formSchema,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.formSchema = $event)
        }, null, 8, ["modelValue"])], 512), [[_vShow, activeTab.value === 'form']])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("button", {
          onClick: _cache[10] || (_cache[10] = $event => _ctx.$emit('close')),
          class: "btn-secondary"
        }, " 取消 "), _createElementVNode("button", {
          onClick: handleSave,
          class: "btn-primary"
        }, " 确定 ")])]),
        _: 1
      });
    };
  }
};